import * as Yup from 'yup';
import { useState, useContext } from 'react';
import { useFormik, Form, FormikProvider } from 'formik';
import { useNavigate } from 'react-router-dom';

// material
import { Stack, TextField, Alert} from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { ThemeProvider } from '@mui/material/styles';
import Theme from '../../../components/Button';

import {api, reiniciarToken, cadastrarMesa} from '../../../services/api';

// context
import { AuthContext } from '../../../contexts/auth';

// ----------------------------------------------------------------------

export default function CadMesaForm() {

  const { logout } = useContext(AuthContext);
  const navigate = useNavigate();

  const [status, setStatus] = useState({
    type: '',
    mensagem: ''
  })

  const RegisterSchema = Yup.object().shape({
    codigo_mesa: Yup.string().required('Código da Mesa é obrigatório'),
    descricao: Yup.string().min(2, 'Muito Pequeno!').max(500, 'Muito Longo!').required('Descrição é obrigatório'),
  });

  const formik = useFormik({
   initialValues: {
        codigo_mesa: '',
        descricao: '',
    },
    validationSchema: RegisterSchema,
    onSubmit: () => {
      navigate('/dashboard', { replace: true });
    },
  });

  const handleSubmit = async e => {
    e.preventDefault();

    const retorno = await reiniciarToken();
    if(retorno.erro === true) {
      if (retorno.mensagem === 'O Token é inválido!' || retorno.mensagem === 'Acesso negado!'){
        logout();
      }
    }else{
      localStorage.setItem("token", retorno.data.token);
      api.defaults.headers.Authorization = `Bearer ${retorno.data.token}`;
    }

    const json = {codigo_mesa: formik.values.codigo_mesa,
                  descricao: formik.values.descricao,
                  id_empresa: localStorage.getItem(['id_empresa'])};

    const response = await cadastrarMesa(json);

    if(response.erro === true) {
      if (response.mensagem === 'O Token é inválido!'){
        logout();
      }else {
        setStatus({
          type: "erro",
          mensagem: response.mensagem
        })
      }
    }else {
      setStatus({
        type: "success",
        mensagem: response.data.mensagem
      })
    }; 
  }

  const { errors, touched, isSubmitting, getFieldProps} = formik;
  
  return (
    <FormikProvider value={formik}>
      <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
        <Stack spacing={3}>
          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
            <TextField 
              fullWidth
              label="Código Mesa"
              {...getFieldProps('codigo_mesa')}
              error={Boolean(touched.codigo_mesa && errors.codigo_mesa)}
              helperText={touched.codigo_mesa && errors.codigo_mesa}
            />
          </Stack>
          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
            <TextField 
              fullWidth
              label="Descrição"
              {...getFieldProps('descricao')}
              error={Boolean(touched.descricao && errors.descricao)}
              helperText={touched.descricao && errors.descricao}
            />
          </Stack>
          
          <Stack spacing={3}>
            {status.type === 'erro' ? <Alert severity="error">{status.mensagem}</Alert> : ""}
            {status.type === 'success' ? <Alert severity="success">{status.mensagem}</Alert> : ""}
          </Stack>

          <ThemeProvider theme={Theme}>
            <LoadingButton fullWidth size="large" type="submit" variant="contained" color="neutral" loading={isSubmitting}>
              Cadastrar
            </LoadingButton>
          </ThemeProvider>
        </Stack>  
      </Form>
    </FormikProvider>
  );
}
